import React, {FunctionComponent, useMemo} from "react";
import {SectionWithBackgroundShape} from "../../interfaces/sectionWithBackgroundShape.interface";
import {SectionPadding} from "../../enums";
import {KlearMapSVG} from "./klearMapSVG/klearMapSVG.component";

const styles = require("./klearMap.component.scss");

interface KlearMapProps extends SectionWithBackgroundShape{
    title: string;
    customersNum: string;
    employeesNum: string;
    officesNum: string;
    sectionPadding: SectionPadding;
}

interface KlearMapNum {
    num: string;
    text: string;
}


export const KlearMap: FunctionComponent<KlearMapProps> = props => {
    const {title, customersNum, employeesNum, officesNum, sectionPadding} = props;

    const textData = useMemo(() => {
        const arr = [];
        arr.push({num: customersNum, text: 'customers in over 120 countries'});
        arr.push({num: employeesNum, text: 'employees around the world'});
        arr.push({num: officesNum, text: 'offices in over 120 countries'});
        return arr;
    }, [customersNum, employeesNum, officesNum]);

    return (
        <div className={styles.cardBackground}>
            <div className={`${styles.cardWrapper} ${styles[sectionPadding]}`}>
                <div className={styles.mapContainer}>
                    <div className={styles.mapText}>
                        <h2 className={styles.mapTitle}>{title}</h2>
                    </div>
                    <KlearMapSVG />
                    <div className={styles.klearNumbers}>
                        {textData && textData.map((data: KlearMapNum) =>
                            <div className={styles.klearNumbersBox}>
                                <div className={styles.klearNumbersTitle}>{data.num}</div>
                                <div className={styles.klearNumbersSubTitle}>{data.text}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
